﻿/*
 * Purpose: Manage T&Cs acceptance state and validation status.
 * Boundary: Hook only; owns state, effects, and handlers; no UI rendering.
 * Invariants:
 * - Validation passes only when button is checked (accepted).
 * - ASCII only; no Unicode characters in comments or strings.
 */

// Imports
import { useState, useEffect } from 'react';

// Hook useListOfCheckboxes:
// Tracks acceptance state, updates validity, and syncs state to parent
export function useListOfCheckboxes({ options = [], onChange = () => { } }) {
    // States: Acceptance and validity
    const [checked, setChecked] = useState(false);
    const [isValid, setIsValid] = useState(false);

    // Handler: Toggle acceptance button
    const onAcceptanceChange = (newChecked) => {
        setChecked(newChecked);
    };

    // Effect: Compute validity (button is checked)
    useEffect(() => {
        setIsValid(checked);
    }, [checked]);

    // Effect: Notify parent on state changes
    useEffect(() => {
        onChange({ checked, isValid });
    }, [checked, isValid, onChange]);

    // Return: Options (for text display), state, and handler
    return {
        options,
        checked,
        onAcceptanceChange,
        isValid,
    };
}